module.exports = __webpack_public_path__ + "static/media/MOTORDRIVE.a326c7af.png";